export type Map2D<T> = T[][];

export function create2DMap<T>(
  rows: number,
  cols: number,
  defaultValue: T,
): Map2D<T> {
  const map: Map2D<T> = [];
  for (let i = 0; i < rows; i++) {
    const row: T[] = [];
    for (let j = 0; j < cols; j++) {
      row.push(defaultValue);
    }
    map.push(row);
  }
  return map;
}

export function set2DMapValue<T>(
  map: Map2D<T>,
  x: number,
  y: number,
  value: T,
): Map2D<T> {
  const newMap = map.map((row) => row.slice());
  if (x >= 0 && x < newMap.length && y >= 0 && y < newMap[0].length) {
    newMap[x][y] = value;
  } else {
    throw new Error('Coordenadas fora do limite do mapa.');
  }

  return newMap;
}
